export const getSWCacheVersion = async (): Promise<string> => {
  return Promise.resolve(import.meta.env.VITE_APP_VERSION);
};
